// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"494":"65f1bc6c","746":"65f1bc6c"}[chunkId] + ".chunk.css";
};